<script setup lang="ts">
import {onMounted} from 'vue';
import {mergeMap} from 'rxjs/operators';
import Map from './components/Map.vue'
import {CustomObservable} from '@/libraries/observable/CustomObservable';
import MapService from '@/services/Map.service';
import MapFeaturesService from '@/services/MapFeatures.service';
import EventMapService from '@/services/EventMap.service';

const mapService: MapService = MapService.getInstance();
const mapFeaturesService: MapFeaturesService = MapFeaturesService.getInstance();
const eventMapService: EventMapService = EventMapService.getInstance();

onMounted(() => {
  CustomObservable.empty().pipe(
      mergeMap(() => mapService.renderFeatures([])),
      mergeMap(() => mapFeaturesService.loadAllFeatures(eventMapService.eventMap().geoId)),
      mergeMap(() => mapService.renderFeatures(mapFeaturesService.allFeatures())),
  ).subscribe();
});
</script>

<template>
  <Map class="map-component"/>
</template>

<style lang="scss" scoped>
.map-component {
  height: 600px;
}
</style>
